import React from 'react';

function RenderCounselingFollowUp({ data, id }) {
  return (
    <div className="smart-tag-sec qcontent-line-break">
      <div className="smart-tag-bdy" id={'sectionVal_' + id}>
        {data?.renderTherapyData?.map((item, i) => (
          <div key={i} className="qsmart-tag-bdy-rw width100 recrd-nt-rw">
            {item[2]?.length > 0 && (
              <div className="cntnt-blk-hdng qfrst-sec-lbl qrecrd-nt-prnt-hdng">
                {item[1]}
              </div>
            )}
            {item[2] &&
              item[2]?.map((subItem, j) => (
                <div key={j} className="smart-tag-bdy-rw">
                  <span className="frst-sec-lbl">{subItem?.label}:</span>
                  <span
                    className="frst-sec-val sec-colr"
                    dangerouslySetInnerHTML={{
                      __html: subItem?.content.replace(/<br\s*\/?>/gi, ''),
                    }}
                  />
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default RenderCounselingFollowUp;
